
import ImageLoader from "@/assets/scripts/ImageLoader";
import HeaderLayout from "@/components/layouts/Header.vue";
import BannerLayout from "@/components/layouts/Banner.vue";
import FooterLayout from "@/components/layouts/Footer.vue";
import DoubleBlock from "@/components/blocks/Double.vue";

export default {
  name: "IndexView",
  components: {
    HeaderLayout,
    BannerLayout,
    FooterLayout,
    DoubleBlock,
  },
  data() {
    return {
      experienceImage: ImageLoader.loadImageSrc("assets/images/icons/experience.png"),
      goalImage: ImageLoader.loadImageSrc("assets/images/icons/goal.png"),
      codeImage: ImageLoader.loadImageSrc("assets/images/decorators/code.jpg"),
      computerImage: ImageLoader.loadImageSrc("assets/images/decorators/desktop_custom.jpg"),
    };
  },
};
